import React, {useState, useEffect, useContext} from 'react'
import { CdnImage, CdnPath } from '../../../shared/cdn-image'
import { useLocation } from "@reach/router"
import QuoteContext from "../../quote-context";

const AccommodationTypes = ({ selectedHotel, types, processForm }) => {

	const location = useLocation();
	const {navigation, navigationDispatcher, formDispatcher} = useContext(QuoteContext);


	useEffect(() => {
		window.scrollTo({
			top: 137,
			behavior: 'smooth'
		})
	}, [])



	const pickCategory = ( hotelStandard, event ) => {
		event.preventDefault();
		this.props.handleAccomTypeSelect( { id: hotelStandard.id, name: hotelStandard.name } );
	}

	const viewHotel = ( hotelStandard ) => {

		navigationDispatcher({
			type: 'OPEN_MODAL',
			modal: './quote/modal/default-hotel',
			title: `${hotelStandard.name} Accommodation`,
			payload: {
				siteId: navigation.siteId,
				id: hotelStandard.id,
				type: 'accomtype',
				selected: selectedHotel.id == hotelStandard.id,
				accomType: hotelStandard,
				day: parseInt(location.state.day),
				hasButton: true,
				addHotel: ( selectedHotel ) => {
					formDispatcher({type:"ADD_HOTEL", hotel: selectedHotel});
					navigationDispatcher({ type: "GOTO_STEP", step: "itinerary", params: null});
					navigationDispatcher({
						type: 'TRACK_EVENT',
						action: 'event',
						category: 'click',
						name: 'add-default-hotel',
						trigger: 'web-js',
						data: {
							day: selectedHotel.day,
							id: selectedHotel.id,
							name: selectedHotel.name,
							nights: selectedHotel.nights
						}
					});
				}
			}
		})

		/*
		navigationDispatcher( { type: 'OPEN_MODAL', modal: 'DefaultHotelInfo', title: hotelStandard.name, payload: {
			id: hotelStandard.id,
			type: 'accomtype',
			selected: selectedHotel.id == hotelStandard.id,
			accomType: hotelStandard,
			day: parseInt(location.state.day)
		}});
		*/

		navigationDispatcher({
			type: 'TRACK_EVENT',
			action: 'event',
			category: 'click',
			name: 'view-default-hotels',
			trigger: 'web-js',
			data: {
				id: hotelStandard.id,
				name: hotelStandard.name
			}
		});
	}

	return (
		<div className="full-width-block">
			<div className="row no-padding">
				<div className="column">

					<div className="full-width-block white pd-v">
						<div className="row">
							<div className="column">
								<h2 className="pd-t-dsk">Choose from one of our {navigation.tag} friendly accommodation options</h2>
							</div>
						</div>		
					</div>

					<div className="full-width-block">
						<div className="row no-padding">
							<div className="column">
								<div className="pd-h-tch pd-h-dsk-md">
									<div className="content-block shadow-dsk radius">
										<div className="pd-dsk-md pd-t-dsk-lrg">
											<div className="full-width-block">
												<div className="row no-padding">
													<div className="align-content grid wrap">
														{types.map( hotelStandard =>
															<div key={`accom-type` + hotelStandard.id} className="grid-item one-quarter mg-b">
																
																<a onClick={() => viewHotel( hotelStandard )}>
																	<div className="full-width height-200" style={navigation.siteId == 1 ? {marginBottom: "1rem", backgroundSize: 'cover', backgroundImage: `url(/global/img/accommodation/` + hotelStandard.ident + `.jpg)`, borderRadius: "0.3rem"} : {marginBottom: "0", backgroundSize: 'cover', backgroundImage: `url(/global/img/accommodation/` + hotelStandard.ident + `.jpg)`, borderTopLeftRadius: "0.5rem", borderTopRightRadius: "0.5rem"}}></div>
																	<div className={navigation.siteId == 1 ? '' : 'bg-light-grey pd radius-b-lrg'}>
																		<p className="text-medium bold">{hotelStandard.name}</p>
																	</div>
																</a>
																{selectedHotel.id == hotelStandard.id ? (
																	<button className={ selectedHotel.id == hotelStandard.id ? `button remove` : `button add`} onClick={(event) => pickCategory( hotelStandard, event )}>{ selectedHotel.id == hotelStandard.id ? 'Remove' : 'Add'}</button>
																) : null}
															
															</div>
														)}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>		
					</div>

					<div className="full-width-block white pd-v">
						<div className="row no-padding full-width">
							<div className="pd-h-tch pd-h-dsk-md">
								<button className="button secondary radius" onClick={() => navigationDispatcher({ type: "GOTO_STEP", step: navigation.hasHotels ? "accommodation" : "itinerary", params: { isPackage: false } })}><span className="icon icon-chevron-left white small left"></span> Back</button>
							</div>
						</div>		
					</div>
				</div>
			</div>
			{/* <div className="skip__buttons--desktop bottom">
				<button className="button accom-button" onClick={this.props.handleSkipHotel}>No accommodation needed!</button>
			</div> */}
		</div>
	)
}

export default AccommodationTypes;
